import { createBasicSelector } from 'util/redux'
import { emptyObj } from 'util/objects'

import { selectBase } from './selectBase'

export const selectAiInstantReply = createBasicSelector(
  selectBase,
  base => base.instantReplyRequest || emptyObj
)
